import type { Article } from "@core/features/support";
import { VideoMeetingMaterials } from "./VideoMeetingMaterials";

type Props = {
  article: Article | null;
  scrollContainer?: HTMLElement | null;
};

export function VideoMeetingMaterialsContainer({ article, scrollContainer }: Props) {
  if (!article) return null;

  return (
    <VideoMeetingMaterials article={article} scrollContainer={scrollContainer} />
  );
}

export default VideoMeetingMaterialsContainer;
